import React, { Fragment, memo, useEffect, useState } from "react";
import { Flex, Text, Button, Box, Divider, Link, Spacer, useDisclosure } from "@chakra-ui/react";
import { SelectedIcon } from "@/icon/SelectedIcon";
import { isLogin } from "@/utils/tools";
import { motion } from "framer-motion";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TwitterIcon } from "@/icon/TwitterIcon";
import { setVersionLevel } from "@/services/user";
import { setUserInfoLevelAction } from "@/components/profile/store/action";
import VipWarningModal from "@/components/modal/vip-modal"
import { FROM_BUY_PRO, FROM_BUY_STANDARD, FROM_TRIAL_PRO, FROM_TRIAL_STANDARD, VERSION_CUSTOMISED, VERSION_PRO, VERSION_STANDARD } from "@/components/getstart/constants";
export default memo(function PriceItemComponent({ item, warning }) {
   const { onOpen, onClose, isOpen } = useDisclosure();
   const navigate = useNavigate();
   const dispatch = useDispatch()
   const token = window.localStorage.getItem("token");
   const [bLogin, setBLogin] = useState(false);
   const { twitter_screen_name, id, vip_level, vip_expire_sec } = useSelector(
      (state) => ({
         twitter_screen_name: state.user.twitter_screen_name,
         id: state.user.id,
         vip_level: state.user.vip_level,
         vip_expire_sec: state.user.vip_expire_sec
      }),
      shallowEqual
   );
   useEffect(() => {
      setBLogin(isLogin(token, id));
   }, [id, token]);
   function showCustomisedComponent() {
      return (
         <>
            <Flex mb="35px" alignItems={"baseline"} justifyContent="center">
               <Text display={{ base: 'block', BREAK_PAD: 'none', BREAK_LPC: 'block' }} variant={"bold"} color='black' fontSize={16}>
                  Start from
               </Text>
               <Text display={{ base: 'none', BREAK_PAD: 'block', BREAK_LPC: 'none' }} alignSelf={'center'} lineHeight={'17px'} variant={"bold"} color='black' fontSize={16}>Start<br /> from</Text>
               <Text variant={"bold"} color='black' fontSize={34} mx="6px">
                  {item.price}ETH
               </Text>
               <Text variant={"bold"} color='#666' fontSize={16}>
                  /year
               </Text>
            </Flex>
            <Link href={process.env.REACT_APP_TWITTER_URL} isExternal w={'full'} maxW={'280px'} >
               <Button
                  bg={"black"}
                  w="full"
                  fontSize={16}
                  colorScheme={"black"}
                  _hover={{base:{},BREAK_LPC:{color:"aloha_blue"}}}
                  _active={{color:'aloha_blue'}}
                  color={"white"}
                  borderRadius={"30px"}
                  rightIcon={<TwitterIcon boxSize={"20px"} />}
                  height={"48px"}>
                  DM
               </Button>
            </Link>
            <Button display={{base:'none',BREAK_PAD:'block'}}
               visibility={"hidden"} mt={"20px"} w={"full"} height={"48px"} >

            </Button>
         </>
      );
   }
   function showNormalComponent() {
      return (
         <>
            <Flex mb="35px" alignItems={"baseline"} justifyContent="center">
               <Text variant={"bold"} fontSize={34} color={'black'}>
                  {item.price}ETH
               </Text>
               <Text variant={"bold"} fontSize={16} color='#666' ml={"6px"}>
                  /year
               </Text>
            </Flex>
            <Button
               w={"full"}
               fontSize={16}
               maxW={'280px'}
               bgColor={'green.500'}
               _hover={{base:{},BREAK_LPC:{bgColor:"green.600"}}}
               _active={{bgColor:'green.600'}}
               color={"white"}
               colorScheme={'black'}
               borderRadius={"30px"}
               onClick={(e) => {
                  if (!bLogin) {
                     navigate("/getstart", { state: { version: (item.type === VERSION_STANDARD ? FROM_BUY_STANDARD : FROM_BUY_PRO) } });
                  } else if (vip_expire_sec > 0 && vip_level === 2 && item.type === VERSION_STANDARD) {
                     warning(true)
                  } else {
                     navigate(`/${twitter_screen_name}/pay`, { state: { version: item.type } });
                  }
               }}
               height={"48px"}>
               Get Started
            </Button>
            <Button
               bg={"white"}
               mt={"20px"}
               maxW={'280px'}
               w={"full"}
               fontSize={16}
               colorScheme={"green"}
               variant={"outline"}
               borderRadius={"30px"}
               onClick={(e) => {
                  if (!bLogin) {
                     navigate("/getstart", { state: { version: (item.type === VERSION_STANDARD ? FROM_TRIAL_STANDARD : FROM_TRIAL_PRO) } });
                  } else if (vip_expire_sec > 0) {
                     onOpen()
                  } else if (vip_expire_sec === -1) {
                     navigate(`/${twitter_screen_name}/mybot`);
                  } else if ((item.type ===VERSION_STANDARD && vip_level === 2) || (item.type ===VERSION_PRO && vip_level === 1)) {
                     warning(false)
                  } else {
                     if (vip_level === 0) {
                        changeVersion(item.type === VERSION_STANDARD ? 1 : 2)
                     } else {
                        navigate(`/${twitter_screen_name}/mybot`);
                     }
                  }
               }}
               height={"48px"}>
               Trial
            </Button>
         </>
      );
   }
   async function changeVersion(version) {
      const res = await setVersionLevel(id, version);
      if (res.code === 0) {
         dispatch(setUserInfoLevelAction(version))
         navigate(`/${twitter_screen_name}/mybot/set`);
      }
   }
   return (
      <Flex
         as={motion.div}
         whileHover={{ y: "-10px" }}
         flex={1}
         py={{ base: '30px', BREAK_PAD: '18px', BREAK_LPC: '40px' }}
         flexDir={"column"}
         borderRadius={"12px"}
         border={"1px solid #E6E6E6"}>
         <Flex flexDir={"column"} px={{ base: "30px", BREAK_PAD: "24px" }}>
            <Text
               variant={"bold"}
               fontSize={20}
               color="black">
               {item.type}
            </Text>
            <Text fontSize={16} lineHeight={"22px"} mt={'6px'} color="#666" height={{ base: '80px', BREAK_PAD: '132px', BREAK_LPC: '106px', BREAK_PC: '80px' }}>
               {item.info}
            </Text>
            <Spacer />
            <Flex flex={1} flexDir={"column"} alignItems='center'>
               {item.type === VERSION_CUSTOMISED ? showCustomisedComponent() : showNormalComponent()}
            </Flex>
         </Flex>
         <Divider mt={"40px"} borderColor='#E6E6E6' />
         <Flex px={{ base: "30px", BREAK_PAD: "24px" }} pt={"16px" } flexDir={"column"}>
            <Text mt={"14px"} display={item.type === VERSION_CUSTOMISED ? "block" : "none"} variant={"bold"}
               fontSize={16}>
               All the goodness of Pro Version, and:
            </Text>
            {item.list.map((bean, index) => {
               return (
                  <Fragment key={index}>
                     {bean.type === "string" ? (
                        <>
                           <Flex mt={"14px"}>
                              <SelectedIcon size={"14px"} mt={"6px"} color={"green.500"} />
                              <Text
                                 ml={{ base: "10px", BREAK_LPC: "15px" }}
                                 color="#333"
                                 fontSize={16}
                                 lineHeight={"26px"}>
                                 {bean.info}
                              </Text>
                           </Flex>
                        </>
                     ) : (
                        <>
                           {bean.list.map((value, index) => {
                              return (
                                 <Flex
                                    key={index}
                                    lineHeight={"26px"}
                                    mt={"2px"}
                                    ml={{ base: "25px", BREAK_LPC: "30px" }}>
                                    <Box
                                       bg="#999"
                                       visibility={value === "..." ? "hidden" : "visible"}
                                       borderRadius={"full"}
                                       w={"4px"}
                                       h={"4px"}
                                       mt={"10px"}
                                    />
                                    <Text flex={1}
                                       fontSize={16} color="#999" ml={"12px"}>
                                       {value}
                                    </Text>
                                 </Flex>
                              );
                           })}
                        </>
                     )}
                  </Fragment>
               );
            })}
         </Flex>
         <VipWarningModal isOpen={isOpen} onClose={onClose} />
      </Flex>
   );
});
